"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _multiUserSelect = _interopRequireDefault(require("@/views/cms/common/multiUserSelect"));

var _cust = _interopRequireDefault(require("@/api/cust"));

//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "index",
  components: {
    UserSelect: _multiUserSelect.default
  },
  props: {
    transUser: {
      type: Object,
      required: true
    },
    permission: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      showUserSelect: false
    };
  },
  methods: {
    onTransCustShow: function onTransCustShow() {
      console.log(this.transUser);
      this.showUserSelect = true;
      this.transUserName = this.transUser.username;
      this.$refs.userSelect.selectType = '推广';
    },
    onUserSelectClose: function onUserSelectClose() {
      this.showUserSelect = false;
    },
    selectUserCallBack: function selectUserCallBack(user) {
      var _this = this;

      console.log(user);
      this.$confirm('此操作将' + this.transUser.nickName + '的所有客户转移给' + user.nickNames, '是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var changeInfo = {
          type: user.selectType,
          userNames: user.userNames,
          transUserName: _this.transUserName
        };

        _cust.default.transCust(changeInfo).then(function (res) {
          _this.$notify({
            title: '转移成功',
            type: 'success',
            duration: 1500
          });

          _this.showUserSelect = false;
        }).catch(function (err) {
          _this.showUserSelect = false;
          console.log(err.response.data.message);
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消转移'
        });
      });
    }
  }
};
exports.default = _default;